//@flow
import * as React from 'react';

import {
  Container
} from 'flux/utils';
import Store from './NotifierStore';

import Notifier from './Notifier'

type Props = {
  mode: string // "alert" | "inline"
}
class NotifierContainer extends React.Component < Props > {

  static getStores() {
    return [Store];
  }

  static calculateState(prevState) {
    return {
      store: Store.getState(),
    };
  }
  render() {
    let nt = this.state && this.state.store ? this.state.store : null;
    return <Notifier notifications={nt} mode={this.props.mode}/>
  }
}

export default Container.create(NotifierContainer);